import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    console.log("HubSpot controller connected")
  }

  // Open HubSpot chat widget with pre-filled message for service user increase
  requestServiceUserIncrease(event) {
    event.preventDefault()
    this.openChatWithMessage("Hi, I'd like to request an increase to my service user limit.")
  }

  // Open HubSpot chat widget with pre-filled message for team member increase
  requestTeamMemberIncrease(event) {
    event.preventDefault()
    this.openChatWithMessage("Hi, I'd like to request an increase to my team member limit.")
  }

  // Open HubSpot chat widget with pre-filled message for feature access
  requestFeatureAccess(event) {
    event.preventDefault()
    const feature = event.target.dataset.feature || "this feature"
    this.openChatWithMessage(`Hi, I'd like to request access to ${feature}.`)
  }

  // Generic method to open chat with pre-filled message
  openChatWithMessage(message) {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open()
      // Note: HubSpot doesn't support pre-filling messages via API
      // Users will need to type their message manually
      // Consider showing a tooltip or notification with the suggested message
    } else {
      console.warn("HubSpot chat widget not loaded")
      // Fallback: could open a contact form or show an email address
    }
  }

  // Open chat widget
  openChat(event) {
    event.preventDefault()
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open()
    }
  }

  // Close chat widget
  closeChat(event) {
    event.preventDefault()
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.close()
    }
  }
}